const Success = () => (
  <svg fill='none' viewBox='0 0 24 24'>
    <path fill='#43D9AD' fillOpacity='.2' d='M2.667 2.667h18.776v18.56H2.667V2.668Z' />
    <path
      fill='#43D9AD'
      d='M5.333 0h13.334v2.667H5.333V0Zm0 21.333h13.334V24H5.333v-2.667Zm16-16H24v13.334h-2.667V5.333ZM0 5.333h2.667v13.334H0V5.333Zm21.333-2.666h-2.666v2.666h2.666V2.667Zm-16 0H2.667v2.666h2.666V2.667Zm0 16H2.667v2.666h2.666v-2.666Z'
    />
    <path fill='#43D9AD' d='M21.333 18.667h-2.666v2.666h2.666v-2.666Z' />
    <path
      fill='#43D9AD'
      fillRule='evenodd'
      d='M16.5 7.5H18V9h-1.5V7.5Zm-1.5 3V9h1.5v1.5H15ZM13.5 12v-1.5H15V12h-1.5ZM12 13.5h1.5V12H12v1.5ZM10.5 15H12v-1.5h-1.5V15ZM9 15v1.5h1.5V15H9Zm-1.5-1.5H9V15H7.5v-1.5Zm0 0H6V12h1.5v1.5Z'
      clipRule='evenodd'
    />
  </svg>
)

export { Success }
